import * as React from "react";
import {
    BaseStateModel,
    ComponentElement,
    ComponentElementDisplayMode
} from "@bizform/type/model/component_element/ComponentElement.model";
import { ComponentElementProperty } from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { PluginType } from "@bizform/type/model/model/Plugin.model";
import { DataType } from "@bizform/type/model/model/DataType.model";

/**
 * @since 0.0.1
 * @author Jongkwang Park, Heungsoo Ham
 * @class
 */
export abstract class AbstractComponentElement<T, P extends BaseStateModel> extends React.Component<T, P> implements ComponentElement<null> {
    static readonly pluginType: string = PluginType.COMPONENTELEMENT;

    destroyed: boolean;
    accessibility: boolean;
    elementId: string;
    applicationId: string;
    formId: string;
    dataType: DataType;
    displayMode: ComponentElementDisplayMode;
    defaultDateFormat: string;
    parentDom: HTMLElement;

    // tabIndex 기억
    protected ___tabindex?: number;

    protected constructor(props?: T) {
        super(props);
    }

    onEdit(): void {
        this.setState({
            show: true,
            displayMode: ComponentElementDisplayMode.EDIT
        }, this.onHandlerCallback);
    }

    onReadOnly(): void {
        this.setState({
            show: true,
            displayMode: ComponentElementDisplayMode.READONLY
        }, this.onHandlerCallback);
    }

    onDisabled(): void {
        this.setState({
            show: true,
            displayMode: ComponentElementDisplayMode.DISABLED
        }, this.onHandlerCallback);
    }

    onPrint(): void {
        this.setState({
            show: true,
            displayMode: ComponentElementDisplayMode.PRINT
        }, this.onHandlerCallback);
    }

    readyComponent(): void {
    }

    onHandlerCallback(): void {
    }

    abstract setProperty(property: ComponentElementProperty): void;
    abstract initDone(): void;
    abstract destroy(): void;
    abstract destroyDone(): void;
}